module.exports = __webpack_public_path__ + "img/MX-C130086A-BS-HQ.333fb2ec.png";